module.exports = __webpack_public_path__ + "static/the-road-to-serfdom-1ba9b8eec138832bb2e7678f2897904b.jpg";